import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "desktop-screen",
  "use": "desktop-screen-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"desktop-screen\"><path d=\"M29 4H3a1 1 0 00-1 1v18a1 1 0 001 1h12v2h-4v2h10v-2h-4v-2h12a1 1 0 001-1V5a1 1 0 00-1-1zm-1 18H4V6h24z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/desktop-screen.svg
// module id = FkXf
// module chunks = 39 44